import { exportQuickCashflowModelToDrive } from 'api/quickCashflowModelApi';
import { buildClientCohortSlidesBlob } from './exportClientCohortSlides';
import { buildDealIrrModelExcelBlob } from './exportDealIrrModelExcel';
import { buildQuickCashflowExcelBlob } from './exportQuickCashflowExcel';
import { buildRoasOverviewOdtBlob } from './exportRoasOverviewOdt';
import { runCalc } from './runCalc';
import { hasCohortSheet } from './roasSaturation';

async function buildRoasOverviewExportSafe(options) {
  try {
    return await buildRoasOverviewOdtBlob(options);
  } catch {
    return null;
  }
}

async function buildDealIrrModelExportSafe(options) {
  try {
    return await buildDealIrrModelExcelBlob(options);
  } catch {
    return null;
  }
}

export async function exportQuickCashflowToDrive({
  customerId,
  calcResult = null,
  state,
  calcTimestamp,
  filenameBase = 'quick-cashflow',
  cohortExportOptions = null,
  executiveView = false,
  scenarioResults = null,
  companyName = null,
  hillModel = null,
  dealIrrModel = null,
  dealIrrInputs = null,
  includeCashflowSheets = true,
}) {
  const resolvedCalcResult = calcResult ?? (state ? runCalc(state) : null);
  const resolvedCompanyName =
    companyName ?? cohortExportOptions?.companyName ?? filenameBase;

  const excel = await buildQuickCashflowExcelBlob({
    calcResult: resolvedCalcResult,
    state,
    calcTimestamp,
    filenameBase,
    cohortExportOptions,
    executiveView,
    scenarioResults,
    includeCashflowSheets,
  });

  const [pptx, roasOverview, dealIrr] = await Promise.all([
    dealIrrModel || resolvedCalcResult != null
      ? buildClientCohortSlidesBlob({
          calcResult: dealIrrModel ? null : resolvedCalcResult,
          dealIrrModel,
          dealIrrInputs,
          state,
          filenameBase,
        })
      : Promise.resolve(null),
    hasCohortSheet(state?.cohortSheet)
      ? buildRoasOverviewExportSafe({
          cohortSheet: state.cohortSheet,
          companyName: resolvedCompanyName,
          filenameBase,
        })
      : Promise.resolve(null),
    state
      ? buildDealIrrModelExportSafe({
          state,
          hillModel,
          filenameBase,
        })
      : Promise.resolve(null),
  ]);

  if (!excel) {
    throw new Error('Nothing to export');
  }

  return exportQuickCashflowModelToDrive({
    customerId,
    modelName: filenameBase,
    excelBlob: excel.blob,
    excelFilename: excel.filename,
    pptxBlob: pptx?.blob?.size ? pptx.blob : null,
    pptxFilename: pptx?.filename ?? null,
    odtBlob: roasOverview?.blob?.size ? roasOverview.blob : null,
    odtFilename: roasOverview?.filename ?? null,
    dealExcelBlob: dealIrr?.blob?.size ? dealIrr.blob : null,
    dealExcelFilename: dealIrr?.filename ?? null,
  });
}
